// Which free-text sections each template shows, in order: label, body key, and the
// field hint (calendar#46 / PROGRESS_NOTE_A-15, verbatim). The Credify Note's chip and
// response sections are rendered around its two text fields (see CredifyNoteFields).
// ehr#437 (PROGRESS_NOTE_10-14-V81 TEMPLATES): SOAP and DAP carry Client response after Objective
// (Data), with the Interventions used checklist before it (see lib/noteLayouts.ts).
export const FORMAT_SECTIONS = {
    SOAP: [
        [
            'Subjective',
            'subjective',
            'Client-reported experience since last session, in their own words.',
        ],
        ['Objective', 'objective', 'Observable, measurable clinician observations during the session.'],
        ['Client response', 'response', 'How the client responded to the interventions.'],
        [
            'Assessment',
            'assessment',
            'Clinical interpretation of progress toward goals and objectives.',
        ],
        ['Plan', 'plan', 'Next steps, homework, and focus for the following session.'],
    ],
    DAP: [
        ['Data', 'data', 'What was observed and reported during the session.'],
        ['Client response', 'response', 'How the client responded to the interventions.'],
        ['Assessment', 'assessment', 'Clinical interpretation of the data collected.'],
        ['Plan', 'plan', 'Next steps and focus for the following session.'],
    ],
    BIRP: [
        ['Behavior', 'behavior', "Client's presenting behavior and statements during the session."],
        ['Intervention', 'intervention', 'Techniques and interventions the clinician used.'],
        ['Response', 'response', 'How the client responded to the interventions.'],
        ['Plan', 'plan', 'Next steps and focus for the following session.'],
    ],
    CREDIFY: [
        ['Objective', 'objective', 'Observable, measurable clinician observations during the session.'],
        [
            'Assessment',
            'assessment',
            'Clinical interpretation of progress toward goals and objectives.',
        ],
    ],
};
/** The same, by any format name (an unknown one has none). */
export const FORMAT_SECTIONS_V81 = FORMAT_SECTIONS;
//# sourceMappingURL=noteSections.js.map